import * as types from '@common/components/address/store/address.actionType';

export default {
  getByCep: (data) => ({
    type: types.ADDRESS_GET,
    payload: { data },
  }),
  getByCepPorCidade: (data) => ({
    type: types.ADDRESS_GETCEPCIDADE,
    payload: { data },
  }),
  setAddress: (address) => ({
    type: types.ADDRESS_SET,
    payload: address,
  }),
  resetAddress: () => ({
    type: types.ADDRESS_RESET,
  }),
};
